/**
 * What the person actually sees, as a picture (2026-10-21, Guilherme: "make her also see in the presentations while she
 * talks, so she is aware of what users are actually seeing"). The rendered page on screen is captured (the same
 * html2canvas path as the PDF export) at a small size: enough to read a page, small enough for a voice session's channel.
 */
import html2canvas from 'html2canvas-pro';
import { neutralizeOklch } from '@/utils/neutralizeOklch';

/** A JPEG data URL of the node as rendered (≈ 120 kB at most), or null when it cannot be captured. */
export async function snapshotPage(node: HTMLElement | null | undefined, width = 960): Promise<string | null> {
  if (!node) return null;
  const r = node.getBoundingClientRect();
  if (r.width < 10 || r.height < 10) return null;
  try {
    // Editor chrome (selection boxes, handles, the Ask box) is marked data-stage-ui: never part of the page.
    const canvas = await html2canvas(node, { backgroundColor: '#ffffff', scale: Math.min(2, width / r.width), useCORS: true, logging: false, onclone: neutralizeOklch, ignoreElements: (el) => el instanceof HTMLElement && el.hasAttribute('data-stage-ui') });
    for (const q of [0.72, 0.55, 0.4]) {
      const url = canvas.toDataURL('image/jpeg', q);
      if (url.length <= 160_000) return url;
    }
    return null;
  } catch { return null; }
}

/** Waits for the next paint (twice) and a beat for pictures, so the capture shows the page that was just put up. */
export const afterPaint = (ms = 350) => new Promise<void>((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(resolve, ms))));
